<template>
    <li class="list-group-item border-0 py-1">
        <div class="d-flex align-items-center">
            <!-- Freccia di espansione solo se hasChildren -->
            <button class="btn btn-sm btn-link text-decoration-none me-1" @click="toggleExpand"
                v-if="isFolder && node.hasChildren">
                <i :class="node.expanded ? 'fa fa-angle-down text-dark' : 'fa fa-angle-right text-dark'"
                    aria-hidden="true"></i>
            </button>
            <span v-else class="me-4"></span>

            <!-- Checkbox selezione -->
            <input type="checkbox" class="form-check-input me-2" :checked="isVisuallySelected" @change="onToggleSelect" />

            <!-- Nome cartella -->
            <span @click="onSelect" role="button">
                <i v-if="isFolder"
                    :class="node.expanded ? 'fa fa-folder-open text-dark me-2' : 'fa fa-folder text-dark me-2'"
                    aria-hidden="true"></i>
                <i v-else class="fa fa-file text-dark me-2" aria-hidden="true"></i>
                {{filters.accorciaNomeFile(node.name,30) }}
                <span v-if="node.loading" class="spinner-border spinner-border-sm text-dark ms-2" role="status"></span>
            </span>
        </div>

        <!-- Sottolivelli -->
        <ul v-if="node.expanded && Array.isArray(node.children)" class="list-group list-group-flush ms-4">
            <FileManagerTreeNode v-for="(child, idx) in node.children" :key="idx" :node="child"
                @select="$emit('select', $event)" @expand="$emit('expand', $event)"
                @toggle-expand="$emit('toggle-expand', $event)" @toggle-select="$emit('toggle-select', $event)" />
        </ul>
    </li>
</template>

<script>
export default {
    name: 'FileManagerTreeNode',
    props: {
        node: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            filters:global.filters,
        };
    },
    emits: ['select', 'expand', 'toggle-expand', 'toggle-select'],
    computed: {
        isFolder() {
            return this.node.type === 'directory';
        },
        isVisuallySelected() {
            return this.node.selected || this.hasSelectedParent(this.$parent);
        }
    },
    methods: {
        toggleExpand() {
            if (!this.node.expanded) {
                this.$emit('expand', this.node); 
            }
            this.$emit('toggle-expand', this.node);
        },
        onSelect() {
            this.$emit('select', this.node);
        },
        onToggleSelect() {
            this.$emit('toggle-select', this.node);
        },
        hasSelectedParent(parent) {
            while (parent) {
                if (parent.node && parent.node.selected) return true;
                parent = parent.$parent;
            }
            return false;
        }
    }
};
</script>